export default __webpack_public_path__ + "fonts/open-sans-400i.woff";